var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row form-group" },
    [
      _vm.title
        ? _c("label-control", {
            staticClass: "col-12 col-md-4 col-lg-3 col-form-label slim",
            attrs: {
              title: _vm.title,
              required: _vm.required,
              forElement: "businessid"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: [_vm.title ? "col-md-8 col-lg-9" : "", "col-12"] },
        [
          _c("ValidationProvider", {
            attrs: {
              rules: {
                required: true,
                businessId: true,
                businessIdExists: true
              },
              slim: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.modifiedValue,
                          expression: "modifiedValue"
                        }
                      ],
                      staticClass: "form-control",
                      class: _vm.getValidationErrorClasses(errors),
                      attrs: {
                        type: "text",
                        id: "businessid",
                        readOnly: _vm.isReadOnly,
                        "aria-required": _vm.required && !_vm.isReadOnly,
                        "aria-invalid":
                          _vm.required && !_vm.isReadOnly && errors.length > 0
                      },
                      domProps: { value: _vm.modifiedValue },
                      on: {
                        blur: function($event) {
                          return _vm.onBlur()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.modifiedValue = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    errors.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "mb-2",
                            attrs: { id: "validation_errors" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getSingleValidationErrorMsg(errors))
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }